import { InitiativeSelectorDialogState, initiativeSelectorDialogState } from './State'

import {
  SET_IS_DIALOG_OPEN,
  SET_INITIATIVES_OPTIONS,
  RESET,
  TOGGLE_IS_LOADING,
  InitiativeSelectorDialogActions
} from './Actions'

function initiativeSelectorDialogReducer(
  state: InitiativeSelectorDialogState,
  action: InitiativeSelectorDialogActions
): InitiativeSelectorDialogState {
  switch (action.type) {
    case SET_IS_DIALOG_OPEN:
      return Object.assign({}, state, {
        isDialogOpenState: action.payload
      })
    case SET_INITIATIVES_OPTIONS:
      return Object.assign({}, state, action.payload)
    case TOGGLE_IS_LOADING:
      return {
        ...state,
        isLoading: !state.isLoading
      }
    case RESET:
      return initiativeSelectorDialogState
    default:
      return state
  }
}

export default initiativeSelectorDialogReducer
